export class FinanceDNDialogModel {
    constructor(
        public dnNumbers: any,
        public cnValue: any
    ) {}
}